import { MFButton } from "../../../../common/components/MFButton";
import { MFCheckbox } from "../../../../common/components/MFCheckbox";
import MFModal from "../../../../common/containers/MFModal";

export function ModalGenerateFiles({
  isOpen,
  onClose,
  dontShowCreateFilesModal,
  setDontShowCreateFilesModal,
  createFiles,
  label,
  simulationMode,
}) {
  return (
    <MFModal isOpen={isOpen} onClose={onClose}>
      <p className="modal-title">Générer des exports</p>
      <p className="modal-text" style={{ marginBottom: "20px" }}>
        {simulationMode ? (
          <span>
            Votre calcul est une simulation. Après génération des exports, le
            <br />
            statut du calcul restera à “En cours”. Vous pourrez télécharger les
            <br />
            exports, et continuer de modifier le calcul pour générer si besoin
            <br />
            d’autres exports (en mode simulation).
          </span>
        ) : (
          <span>
            En générant les exports, le statut du calcul passera à “Finalisé”.
            <br />
            Vous ne pourrez plus modifier ou supprimer le calcul.
            <br />
            Vous pourrez par contre télécharger les exports, visualiser le
            calcul,
            <br />
            le classer dans les dossiers ou encore l’archiver.
          </span>
        )}
      </p>
      <div className="d-flex flex-column">
        <MFCheckbox
          checked={dontShowCreateFilesModal}
          onChange={(e) => setDontShowCreateFilesModal(e.target.checked)}
          label="Ne plus afficher ce message"
        />
      </div>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={createFiles}>
          {label || "Générer les exports"}
        </MFButton>
      </div>
    </MFModal>
  );
}
